// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION: any = {
  "branch": "master",
  "sha": "a97680f7bd819bff0e24aeedc2337be03dc82489",
  "abbreviatedSha": "a97680f7",
  "tag": "2026.02.0",
  "lastTag": "2026.02.0",
  "commitsSinceLastTag": 0,
  "version": "2026.02.0",
  "commitCount": 2724
};
/* eslint-enable */
